import React from 'react';
import {createPortal} from 'react-dom';

const Modal = ({children, className}) => {
    const modalRoot = document.getElementById('modal');
    return createPortal(<div className={`modal ${className ? className : ''}`}>{children}</div>, modalRoot);
};

export default Modal;
